/**
 * Product Accordion Module
 *
 * Enhances <details> accordion sections on product pages
 * with exclusive open behavior (opening one closes others)
 * and smooth height transitions.
 */

function animateOpen(detail) {
  const content = detail.querySelector(".faq__answer");
  if (!content) {
    return;
  }
  detail.open = true;
  const height = content.scrollHeight;
  content.style.maxHeight = "0px";
  content.style.overflow = "hidden";
  content.style.opacity = "0";
  requestAnimationFrame(() => {
    content.style.transition = "max-height 0.25s ease-out, opacity 0.25s ease-out";
    requestAnimationFrame(() => {
      content.style.maxHeight = `${height}px`;
      content.style.opacity = "1";
    });
  });
  content.addEventListener("transitionend", function handler() {
    content.style.maxHeight = "";
    content.style.overflow = "";
    content.style.transition = "";
    content.style.opacity = "";
    content.removeEventListener("transitionend", handler);
  });
}

function animateClose(detail) {
  const content = detail.querySelector(".faq__answer");
  if (!content) {
    detail.open = false;
    return;
  }
  const height = content.scrollHeight;
  content.style.maxHeight = `${height}px`;
  content.style.overflow = "hidden";
  content.style.opacity = "1";
  requestAnimationFrame(() => {
    content.style.transition = "max-height 0.2s ease-in, opacity 0.15s ease-in";
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px";
      content.style.opacity = "0";
    });
  });
  content.addEventListener("transitionend", function handler() {
    detail.open = false;
    content.style.maxHeight = "";
    content.style.overflow = "";
    content.style.transition = "";
    content.style.opacity = "";
    content.removeEventListener("transitionend", handler);
  });
}

export function init() {
  const container = document.querySelector("[data-product-accordions]");
  if (!container) {
    return;
  }

  const items = container.querySelectorAll("details");

  for (const item of items) {
    item.querySelector("summary").addEventListener("click", (e) => {
      e.preventDefault();

      if (item.open) {
        animateClose(item);
      } else {
        for (const other of items) {
          if (other !== item && other.open) {
            animateClose(other);
          }
        }
        animateOpen(item);
      }
    });
  }
}
